export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 70,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImage',
    width: 70,
    title: that.$l('table_label_image') || '图片',
    headerAlign: 'left',
    align: 'left',
    slots: { default: 'defaultImage' },
  },
  {
    title: that.$l('table_label_displaySku') || '产品信息',
    field: 'displaySku',
    headerAlign: 'left',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displaySku' },
  },
  {
    title: that.$l('table_label_displayStore') || '销售信息',
    field: 'displayStore',
    headerAlign: 'left',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displayStore' },
  },
  {
    title: that.$l('table_label_displaySubmitQty') || '补货数量',
    field: 'displaySubmitQty',
    headerAlign: 'left',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    slots: { default: 'displaySubmitQty' },
  },
  {
    title: that.$l('table_label_displayOperate') || '运营信息',
    field: 'displayOperate',
    headerAlign: 'left',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: { default: 'displayOperate' },
    visible: that.isVc == 'N',
  },
  {
    title: that.$l('table_label_displayFba') || 'FBA货件追踪',
    field: 'displayFba',
    headerAlign: 'left',
    align: 'left',
    minWidth: 280,
    showHeaderOverflow: true,
    slots: { default: 'displayFba' },
  },
]
